module.exports = __webpack_public_path__ + "static/img/gsb.6175476.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bank_logo/gsb.svg
// module id = ax4F
// module chunks = 28 29